/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import firebase from 'firebase/app'
import 'firebase/auth'
import router from '@/router'
import AccountsService from '@/accounts/accountsService.js'
import Vue from 'vue'

export default {
  loginAttempt({
    dispatch
  }, payload) {

    // New payload for login action
    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify
    }

    // If remember_me is enabled change firebase Persistence
    if (!payload.checkbox_remember_me) {

      // Change firebase Persistence
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)

        // If success try to login
        .then(function () {
          dispatch('login', newPayload)
        })

        // If error notify
        .catch(function (err) {
          payload.notify({
            time: 2500,
            title: 'Error',
            text: err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    } else {
      // Try to login
      dispatch('login', newPayload)
    }
  },
  login({
    commit,
    state,
    dispatch
  }, payload) {
    if (payload && (payload.RequestPending || payload.RequestPending === false)) {
      if (payload.success) {
        // Set user info in localStorage and Vuex state
        localStorage.setItem(location.hostname + '-fullUserInfo', JSON.stringify(payload.dataMassaged));
        commit('UPDATE_AUTHENTICATED_USER', payload.dataMassaged);
        
        // Check if we're in a popup (opened by window.open) and send LOGIN_TOKEN message
        if (window.opener) {
          const token = localStorage.getItem(location.hostname + '-token');
          if (token) {
            console.log('Sending LOGIN_TOKEN to parent window');
            window.opener.postMessage({ type: 'LOGIN_TOKEN', token }, '*');
            window.close();
            return; // Don't redirect, just close the popup
          }
        }
        
        // Wait for next tick to ensure state is updated
        Vue.nextTick(() => {
          try {
            const urlParams = new URLSearchParams(window.location.search);
            const returnParam = urlParams.get('return');
            const returnUrl = returnParam ? atob(returnParam) : router.currentRoute.query.to || '/';
            router.push(returnUrl);
          } catch (err) {
            console.error('Error during login redirection:', err);
            router.push(router.currentRoute.query.to || '/');
          }
        });
      } else {
        return;
      }
    }

    if (payload && payload.LoginFailed) {
      delete payload.LoginFailed;
      payload.notify({
        title: 'Login Failed',
        text: 'Could not log you in.',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      });
    } else if (!payload || !payload.success) {
      AccountsService.accountLogin({
        dispatch
      }, payload);
    } else {
      let isUsernameUpdateRequired = false; // TODO: if needed.
      if (!isUsernameUpdateRequired) {
        commit('UPDATE_AUTHENTICATED_USER', payload.userDetails);
        Vue.nextTick(() => {
          router.go(router.currentRoute.query.to || '/');
        });
      }
    }
  },

  // Google Login
  loginWithGoogle({
    commit,
    state
  }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      });
      return false
    }
    const provider = new firebase.auth.GoogleAuthProvider();

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/');
        commit('UPDATE_AUTHENTICATED_USER', result.user.providerData[0])
      }).catch((err) => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      })
  },

  // Facebook Login
  loginWithFacebook({
    commit,
    state
  }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      });
      return false
    }
    const provider = new firebase.auth.FacebookAuthProvider();

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/');
        commit('UPDATE_AUTHENTICATED_USER', result.user.providerData[0])
      }).catch((err) => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      })
  },

  // Twitter Login
  loginWithTwitter({
    commit,
    state
  }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      });
      return false
    }
    const provider = new firebase.auth.TwitterAuthProvider();

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/');
        commit('UPDATE_AUTHENTICATED_USER', result.user.providerData[0])
      }).catch((err) => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      })
  },

  // Github Login
  loginWithGithub({
    commit,
    state
  }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: 'Login Attempt',
        text: 'You are already logged in!',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning'
      });
      return false
    }
    const provider = new firebase.auth.GithubAuthProvider();

    firebase.auth().signInWithPopup(provider)
      .then((result) => {
        router.push(router.currentRoute.query.to || '/');
        commit('UPDATE_AUTHENTICATED_USER', result.user.providerData[0])
      }).catch((err) => {
        payload.notify({
          time: 2500,
          title: 'Error',
          text: err.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      })
  },
  updateUsername({
    commit
  }, payload) {
    payload.user.updateProfile({
      displayName: payload.username
    }).then(() => {

      // If username update is success
      // update in localstorage
      let newUserData = Object.assign({}, payload.user.providerData[0])
      newUserData.displayName = payload.username
      commit('UPDATE_AUTHENTICATED_USER', newUserData)

      // If reload is required to get fresh data after update
      // Reload current page
      if (payload.isReloadRequired) {
        router.push(router.currentRoute.query.to || '/')
      }
    }).catch((err) => {
      payload.notify({
        time: 8800,
        title: 'Error',
        text: err.message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      });
    })
  },
  updateAuthenticatedUser({
    commit
  }, payload) {
    commit('UPDATE_AUTHENTICATED_USER', payload)
  }
}
